// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2afGj","colBig":"styles_colBig__3PRO_","colSmall":"styles_colSmall__1plfr"};